import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import COLORS from 'constants/colors';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';
import { Row, Separator } from '@cuemath/comps';
import { CSVLink } from 'react-csv';

const PieWrapper = styled.div`
  width: 300px;
  padding: 10px;
  border: 2px solid ${COLORS.BLACK};
  position: relative;
`;

const DownloadCsvIcon = styled.i`
  position: absolute;
  right: 0;
  :hover {
    cursor: pointer;
  }
`;

const CsvIcon = styled(CSVLink)`
  color: ${COLORS.BLACK};
`;

const PieHeading = styled(Row)`
  justify-content: center;
  align-items: center;
  font-size: 16px;
  margin-bottom: 5px;
`;

ChartJS.register(ArcElement, Tooltip, Legend);

const getTypes = data => {
  const nodeTypes = [];
  const counts = [];
  const backgroundColors = [];
  const colors = Object.keys(COLORS);
  data &&
    data.forEach(({ node_type, count }, i) => {
      nodeTypes.push(node_type);
      counts.push(count);

      if (i < colors.length) {
        backgroundColors.push(COLORS[colors[i]]);
      } else {
        backgroundColors.push(COLORS[colors[i - colors.length - 1]]);
      }
    });
  return [nodeTypes, counts, backgroundColors];
};

export default function Chart({ worksheetTypes }) {
  const [nodeTypes, counts, backgroundColors] = getTypes(worksheetTypes) || [];
  const data = {
    maintainAspectRatio: false,
    responsive: false,
    labels: nodeTypes,
    datasets: [
      {
        data: counts,
        backgroundColor: backgroundColors,
        borderWidth: 0,
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        labels: false,
      },
    },
  };

  return (
    <PieWrapper>
      {worksheetTypes && (
        <CsvIcon data={worksheetTypes} filename={'Worksheets_data_'}>
          <DownloadCsvIcon className="download icon"></DownloadCsvIcon>
        </CsvIcon>
      )}
      <PieHeading>Worksheets by types</PieHeading>
      <Separator />
      <Pie data={data} options={options} />
    </PieWrapper>
  );
}

Chart.propTypes = {
  worksheetTypes: PropTypes.arrayOf(PropTypes.shape({})),
};
Chart.defaultProps = {
  worksheetTypes: null,
};
